import { createBrowserRouter } from 'react-router-dom';
import { AppShell } from '@/components/layout/AppShell';
import { DashboardPage } from '@/features/dashboard/DashboardPage';
import { ModulePage } from '@/features/_shared/ModulePage';
import { ErrorScreen } from '@/components/system/ErrorScreen';

// Module routes. Feature pages are introduced phase by phase (ROADMAP.md);
// until then each renders a premium placeholder so navigation never breaks.
export const router = createBrowserRouter([
  {
    path: '/',
    element: <AppShell />,
    errorElement: <ErrorScreen />,
    children: [
      { index: true, element: <DashboardPage /> },
      { path: 'clients', element: <ModulePage titleKey="nav.clients" /> },
      { path: 'documents', element: <ModulePage titleKey="nav.documents" /> },
      { path: 'tax-returns', element: <ModulePage titleKey="nav.taxReturns" /> },
      { path: 'portal', element: <ModulePage titleKey="nav.portal" /> },
      { path: 'notarization', element: <ModulePage titleKey="nav.notarization" /> },
      { path: 'payments', element: <ModulePage titleKey="nav.payments" /> },
      { path: 'subscriptions', element: <ModulePage titleKey="nav.subscriptions" /> },
      { path: 'downloads', element: <ModulePage titleKey="nav.downloads" /> },
      { path: 'assistant', element: <ModulePage titleKey="nav.ai" /> },
      { path: 'reports', element: <ModulePage titleKey="nav.reports" /> },
      { path: 'audit', element: <ModulePage titleKey="nav.audit" /> },
      { path: 'security', element: <ModulePage titleKey="nav.security" /> },
      { path: 'sandbox', element: <ModulePage titleKey="nav.sandbox" /> },
      { path: 'settings', element: <ModulePage titleKey="nav.settings" /> },
    ],
  },
]);
